import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
//import { ToastyModule } from "ng2-toasty";

import { LoadingResourceComponent } from './components/loading-resource/loading-resource.component';
import { Int2ipPipe } from './pipes/int2ip.pipe';
import { ShowErrorComponent } from './components/show-error/show-error.component';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';

@NgModule({
  declarations: [
    LoadingResourceComponent,
    Int2ipPipe,
    CurrencyFormatPipe,
    ShowErrorComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbDatepickerModule,
    //ToastyModule.forRoot(),
  ],
  exports: [
    LoadingResourceComponent,
    Int2ipPipe,
    CurrencyFormatPipe,
    ShowErrorComponent,
  ],
})
export class SharedsModule {}
